import React from "react";
import "./footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">AdrianY</h1>

                <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>

                    <li>
                        <a href="#portfolio" className="footer__link">Portfolio</a>
                    </li>

                    <li>
                        <a href="#contact" className="footer__link">Contact</a>
                    </li>

                </ul>

                <div className="footer__social">
                    <a href="https://www.instagram.com/yangaobous/" className="footer__social-icon" target="_blank">
                        <i class="uil uil-instagram"></i>
                    </a>

                    <a href="https://www.linkedin.com/in/adrian-yang-855698236" className="footer__social-icon" target="_blank">
                        <i class="uil uil-linkedin"></i>
                    </a>

                    <a href="https://github.com/klyos77" className="footer__social-icon" target="_blank">
                        <i class="uil uil-github-alt"></i>
                    </a>
                </div>

                <span className="footer__bottomline">Memento mori</span>
            </div>
        </footer>
    )
}

export default Footer